import { enableES5, setUseProxies } from 'immer'
import 'reflect-metadata'

export * from './entities'
export * from './graphs'
export * from './layouts'
export * from './plugins'
export * from './types'

enableES5()
setUseProxies(false)
